var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.$route.meta.external)?[_c('HeadPage')]:_vm._e(),_c('transition',[_c('keep-alive',{attrs:{"include":"Index"}},[_c('router-view')],1)],1),(!_vm.$route.meta.external)?[_c('BottomPage')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }